<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import Input from 'dashboard/components-next/input/Input.vue';
import ColorPicker from 'dashboard/components-next/colorpicker/ColorPicker.vue';

const emit = defineEmits(['submit']);
const { t } = useI18n();

const dialogRef = ref(null);
const stageId = ref(null);
const name = ref('');
const color = ref('#4462F7');
const isSaving = ref(false);

const isEdit = computed(() => Boolean(stageId.value));
const title = computed(() =>
  t(isEdit.value ? 'KANBAN.STAGE.EDIT.TITLE' : 'KANBAN.STAGE.ADD.TITLE')
);
const isInvalid = computed(() => name.value.trim().length < 2);

// os valores precisam ser setados ANTES do open() (o slot do Dialog só
// renderiza quando ele abre)
const open = (stage = null) => {
  stageId.value = stage?.id ?? null;
  name.value = stage?.name ?? '';
  color.value = stage?.color || '#4462F7';
  dialogRef.value.open();
};

const close = () => dialogRef.value.close();
const setSaving = value => {
  isSaving.value = value;
};

const onConfirm = () =>
  emit('submit', {
    id: stageId.value,
    name: name.value.trim(),
    color: color.value,
  });

defineExpose({ open, close, setSaving });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="edit"
    :title="title"
    :confirm-button-label="t('KANBAN.STAGE.FORM.SAVE')"
    :cancel-button-label="t('KANBAN.STAGE.FORM.CANCEL')"
    :disable-confirm-button="isInvalid"
    :is-loading="isSaving"
    width="sm"
    @confirm="onConfirm"
  >
    <div class="flex flex-col gap-4">
      <Input
        v-model="name"
        :label="t('KANBAN.STAGE.FORM.NAME.LABEL')"
        :placeholder="t('KANBAN.STAGE.FORM.NAME.PLACEHOLDER')"
        :message="isInvalid ? t('KANBAN.STAGE.FORM.NAME.ERROR') : ''"
        :message-type="isInvalid ? 'error' : 'info'"
      />
      <div class="flex flex-col gap-1">
        <label class="mb-0.5 text-sm font-medium text-n-slate-12">
          {{ t('KANBAN.STAGE.FORM.COLOR.LABEL') }}
        </label>
        <ColorPicker v-model="color" />
      </div>
    </div>
  </Dialog>
</template>
